import { resolveMediaUrl } from '@/config/app'

/**
 * Normaliza resposta de /workspace-acesso/workspace/{id} para o formato usado no Kanban.
 */
export function mapWorkspaceUsers (usuariosApi) {
  if (!Array.isArray(usuariosApi)) return []
  return usuariosApi.map((usuario) => ({
    id: usuario.usuarioId ?? usuario.id,
    usuarioId: usuario.usuarioId ?? usuario.id,
    nomeCompleto: usuario.usuarioNome || usuario.nomeCompleto || usuario.nome || '',
    usuarioNome: usuario.usuarioNome || usuario.nomeCompleto || usuario.nome || '',
    email: usuario.usuarioEmail || usuario.email,
    fotoPerfil: resolveMediaUrl(usuario.usuarioFotoPerfil || usuario.fotoPerfil) || null,
    roleWorkspace: usuario.roleWorkspace,
    ativo: usuario.ativo
  }))
}

export function findWorkspaceUser (workspaceUsers, userId) {
  const n = Number(userId)
  if (!n) return null
  return workspaceUsers.find((u) =>
    Number(u.id) === n ||
    Number(u.usuarioId) === n ||
    Number(u.userId) === n
  ) || null
}
